import { render, staticRenderFns } from "./CelebrationCard.vue?vue&type=template&id=081eb184&scoped=true"
import script from "./CelebrationCard.vue?vue&type=script&lang=js"
export * from "./CelebrationCard.vue?vue&type=script&lang=js"
import style0 from "./CelebrationCard.vue?vue&type=style&index=0&id=081eb184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081eb184",
  null
  
)

export default component.exports